import React from 'react';

const ComicDisplay = ({ images }) => {
  return (
    <div className="ComicDisplay">
      {images.map((imageUrl, index) => (
        <img key={index} src={imageUrl} alt={`Comic Panel ${index + 1}`} />
      ))}
    </div>
  );
};

export default ComicDisplay;
